import { apiBaseUrl } from "../../configs/app"
import loginService from "../loginService"
import fcmService from "../fcm.service"

const messengeBaseUrl = apiBaseUrl + "messenger/"
export function fetchConversations(page = 1, perPage = 20) {
    return loginService.privateGetApiCall(messengeBaseUrl + "conversation/all", { page, per_page: perPage })
}
export function updateTitle(conversation_id: number, title: string) {
    return loginService.privatePutApiCall(messengeBaseUrl + "conversation/update/title", {
        conversation_id,
        title
    })
}
export function deleteConversation(conversation_id: number) {
    return loginService.privateApiRequest('delete', messengeBaseUrl + "conversation/delete", {
        conversation_id
    })
}
export function fetchConversation(id: number) {
    return loginService.privateGetApiCall(messengeBaseUrl + "message/all/" + id)
}
export function sendMessage(conversation_id: number, message: string) {
    return loginService.privatePutApiCall(messengeBaseUrl + "message/send", {
        conversation_id,
        message
    })
}
export function sendImage(conversation_id: number, imageString: string) {
    return loginService.privatePutApiCall(messengeBaseUrl + "message/send-image", {
        conversation_id,
        imageString
    })
}
export function fetchMessengerUsers(search = '', page = 1) {
    return loginService.privateGetApiCall(messengeBaseUrl + "conversation/users", { search, page, per_page: 20 })
}
export function sendNewMessage(receiver_id: number, conversation_name: string, message: string) {
    return loginService.privatePutApiCall(messengeBaseUrl + "message/new", {
        receiver_id,
        conversation_name,
        message
    })
}
export function unseenCount(){
    return loginService.privateGetApiCall(messengeBaseUrl + "unseen-count")
}

export async function requestFCMPermission() {
    try {
        let permission: NotificationPermission = 'granted'
        if (typeof Notification !== 'undefined' && typeof Notification.requestPermission === 'function') {
            permission = await Notification.requestPermission();
        }
        if (permission === 'granted') {
            // console.log('Notification permission granted.');
            const token = await fcmService.requestToken();
            if (token) {
                await loginService.privatePutApiCall(apiBaseUrl + "update-fcm-token", {
                    fcm_token: token
                })
                // console.log('FCM Token:', token);
            } else {
                console.error('No registration token available. Request permission to generate one.');
            }
        } else {
            console.error('Unable to get permission to notify.');
        }
    } catch (error) {
        console.error('An error occurred while retrieving token.', error);
    }
};
